import ApplicationState from './ApplicationState';

const xhr = ApplicationState.axios;

export default class CompareButton 
{

    protected compareSelector: string = null;

    public constructor(compareSelector: string = null) {

        this.compareSelector = compareSelector;
    }

    public init()
    {
        this.addEventListener();
    }

    protected addEventListener()
    {
        //клик по кнопке "купить" в каталоге и на карточке товара в блоке "аналоги"
        document.querySelectorAll('.js-action-compare').forEach(button => {
            this.appendCompareButtonHandler(button);
        });
    }

    protected appendCompareButtonHandler(button: Element)
    {
        button.addEventListener('click', () => {

            let formData = new FormData;
            let url = button.classList.contains('compare_active') ? '/compare/delete_from_compare/' : '/compare/add_to_compare/';

            formData.append('product_id', button.getAttribute('data-idx'));

            xhr.post(url, formData).then(rsp => {
                if (button.classList.contains('compare_active')) {
                    button.classList.remove('compare_active');
                    button.setAttribute('title', 'Добавить в сравнение');
                    ApplicationState.compareCounter.remove(Number(button.getAttribute('data-idx')));
                } else {
                    button.classList.add('compare_active');
                    button.setAttribute('title', 'Удалить из сравнения');
                    ApplicationState.compareCounter.add(Number(button.getAttribute('data-idx')));
                };

            }).catch(() => {
                // do nothing
            }).then(() => {

            });
        });
    }
}